module.exports = __webpack_public_path__ + "static/media/strahl.70919688.WebP";